import './navbar.scss';
import { Link } from 'react-router-dom';
import { img_documents_app, img_logo_logoWhite_app } from '../../../core/hooks/assetsConstants';
import Separator from '../../content/Separator';
import ButtonNav from '../../content/buttons/button_nav/ButtonNav';

interface NavbarProps {
    pageTitle: string;
}

export default function Navbar({ pageTitle }: Readonly<NavbarProps>) {

    // Descargar guia de la pagina
    const handleDownload = () => {
        const fileUrl = img_documents_app;
        window.open(fileUrl, "_blank");
    };

    return (
        <section className='container_navbar'>

            {/* Derecha */}
            <div className='left'>
                {/* Menu de opciones */}
                <Link to={'/'} className='identity'>
                    <div className='button_general'>
                        <img src={img_logo_logoWhite_app} width="30px" alt="Logo" />
                    </div>
                </Link>

                <Separator />

                {/* Nombre de pagina */}
                <div className='title_page'>{pageTitle}</div>
            </div>

            {/* Izquierda */}
            <div className='right'>
                <div className='buttons_nav'>
                    {/* Boton de orders */}
                    <div>
                        <ButtonNav text={'Acerca de'} url='/acerca-de' />
                    </div>

                    <div>
                        <ButtonNav icon={'fa-regular fa-file'} text={'Guía'} onClick={handleDownload} />
                    </div>

                    <div>
                        <ButtonNav icon={'fa-regular fa-layer-group'} text={'Categorías'} url='/categorias' />
                    </div>

                    <div>
                        <ButtonNav icon={'fa-regular fa-envelope'} text={'Contacto'} url='/contacto' />
                    </div>
                </div>
            </div>

        </section>
    )
}
